import React from "react";
import { components } from "react-select";
import { CountryFlags } from "../../../Utils/Constants";

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="feed-type-selected-value">
        {CountryFlags[data.value] && (
          <img src={CountryFlags[data.value]} alt="type" />
        )}
        {data.label}
      </div>
    </components.SingleValue>
  );
};

export default SingleValue;



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/components/SingleValue.js